export const SchedulingRecommendationMode = {
  Voice: "voice",
  Sms: "SMS",
  None: "none",
} as const;

export type SchedulingRecommendationMode =
  (typeof SchedulingRecommendationMode)[keyof typeof SchedulingRecommendationMode];
